import { render } from "./MentorTaskManage.vue?vue&type=template&id=25328e4b&scoped=true"
import script from "./MentorTaskManage.vue?vue&type=script&lang=js"
export * from "./MentorTaskManage.vue?vue&type=script&lang=js"

import "./MentorTaskManage.vue?vue&type=style&index=0&id=25328e4b&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25328e4b"]])

export default __exports__